import { useCallback, useRef } from 'react';

import { getModuleLogger } from '../LoggerService';
import type { UseOnViewTracker, ViewTrackerCallback } from './types';
import { useTracker } from './useTracker';

const logger = getModuleLogger('useOnViewTracker');

export const useOnViewTracker: UseOnViewTracker = ({
  column,
  component,
  meta,
  product,
  payout,
  defaultPayout,
  stage,
  trigger,
  once,
}) => {
  const track = useTracker();
  const hasFiredOnce = useRef(false);

  return useCallback<ViewTrackerCallback>(
    (trackingInformation) => {
      if (once && hasFiredOnce.current) {
        return;
      }

      hasFiredOnce.current = true;

      track({
        event: 'View',
        column,
        component,
        external: false,
        meta,
        payout,
        defaultPayout,
        product,
        stage,
        trigger,
        ...trackingInformation,
      }).catch((e) => logger.error(`Can't fire View tracker ${trigger}`, e));
    },
    [once, track, column, component, meta, payout, defaultPayout, product, stage, trigger],
  );
};
